/// <reference path="../typings/index.d.ts" />
namespace App {
  export class ConfiguracoesConta {
    private ajax: IAjax;
    public executarCallbackChange: any = null;
    public timeoutSaveDadosAnticaptcha: any = null;
    private elParentModalConfiguracao: JQuery = null;
    private elParentLiRowConta: JQuery = null;
    public idContaEa: string | number = null;
    private elAtivarManterNoCemiterio: JQuery = null;
    private elLanceInfinito: JQuery = null;
    private elAumentarCapacidadeVendaAtiva: JQuery = null;
    private elRelistar: JQuery = null;
    private elRetirarVendidos: JQuery = null;
    private elPularAnimacaoAberturaPacote: JQuery = null;
    private elEvitarPrejuizoVenda: JQuery = null;
    private elAtivarModoBackground: JQuery = null;
    private elAtivarResolvedorDeCaptcha: JQuery = null;
    private elAtivarProxy: JQuery = null;
    private elAtivarModoHumano: JQuery = null;
    private elCampoModopotente: JQuery = null;
    public elCampoNoUiSliderModoPotente: any = null;
    private elNavegadorModificado: JQuery = null;
    private elHeadless: JQuery = null;
    private elEconomizarMemoria: JQuery = null;
    private elBotaoSalvarConfigAnticaptcha: JQuery = null
    private elBotaoSalvarConfigProxy: JQuery = null
    private elFormConfiguracoesSniper: JQuery = null
    private elSelectProtocoloProxy: JQuery = $('.form_ativar_proxy select[name=protocolo]');
    private elInputProxyAddress: JQuery = $('.form_ativar_proxy input[name=proxy_address]');
    private elInputProxyPort: JQuery = $('.form_ativar_proxy input[name=proxy_port]');
    private elInputProxyLogin: JQuery = $('.form_ativar_proxy input[name=proxy_login]');
    private elInputProxyPassword: JQuery = $('.form_ativar_proxy input[name=proxy_password]');

    private elInputAnticaptchaApi: JQuery = $('.form_resolver_captcha_automaticamente input[name=api_key]');
    private elInputProxyAddressAnticaptcha: JQuery = $('.form_resolver_captcha_automaticamente input[name=proxy_address]');
    private elInputProxyPortAnticaptcha: JQuery = $('.form_resolver_captcha_automaticamente input[name=proxy_port]');
    private elInputProxyLoginAnticaptcha: JQuery = $('.form_resolver_captcha_automaticamente input[name=proxy_login]');
    private elInputProxyPasswordAnticaptcha: JQuery = $('.form_resolver_captcha_automaticamente input[name=proxy_password]');
    private versaoWeetalert: number = 1;

    public constructor(elParentModalConfiguracao: JQuery, versaoWeetalert: number = 1) {
      this.versaoWeetalert = versaoWeetalert;
      this.ajax = new App.Ajax();
      this.elParentModalConfiguracao = elParentModalConfiguracao;
      this.elParentLiRowConta = this.elParentModalConfiguracao.parents('.checklist-entry');
      this.elAtivarManterNoCemiterio = this.elParentModalConfiguracao.find("input[name=ativar_manter_no_cemiterio]")
      this.elLanceInfinito = this.elParentModalConfiguracao.find("input[name=ativar_lance_infinito]")
      this.elAumentarCapacidadeVendaAtiva = this.elParentModalConfiguracao.find("input[name=aumentar_capacidade_venda_ativa]")
      this.elRelistar = this.elParentModalConfiguracao.find("input[name=relistar]")
      this.elRetirarVendidos = this.elParentModalConfiguracao.find("input[name=retirar_vendidos]")
      this.elPularAnimacaoAberturaPacote = this.elParentModalConfiguracao.find("input[name=pular_animacao_abertura_pacote]")
      this.elEvitarPrejuizoVenda = this.elParentModalConfiguracao.find("input[name=evitar_prejuizo_venda]")
      this.elAtivarModoBackground = this.elParentModalConfiguracao.find("input[name=modo_background]")
      this.elAtivarResolvedorDeCaptcha = this.elParentModalConfiguracao.find("input[name=resolver_captcha_automaticamente]")
      this.elAtivarProxy = this.elParentModalConfiguracao.find("input[name=ativar_proxy]")
      this.elCampoModopotente = this.elParentModalConfiguracao.find("input[name=modo_potente]")
      this.elAtivarModoHumano = this.elParentModalConfiguracao.find("input[name=modo_humano]")
      this.elBotaoSalvarConfigAnticaptcha = this.elParentModalConfiguracao.find(".btn-salvar-config-anticaptcha")
      this.elBotaoSalvarConfigProxy = this.elParentModalConfiguracao.find(".btn-salvar-config-proxy")
      this.elFormConfiguracoesSniper = this.elParentModalConfiguracao.find(".formulario-alterar-configuracoes-sniper")
      this.elNavegadorModificado = this.elParentModalConfiguracao.find("input[name=navegador_modificado]")
      this.elHeadless = this.elParentLiRowConta.find("input[name=headless]")
      this.elEconomizarMemoria = this.elParentModalConfiguracao.find("input[name=economizar_memoria]")
      this.elAtivarManterNoCemiterio.on('change', (e) => { this.aoSelecionarManterNoCemiterio(e); })
      this.elLanceInfinito.on('change', (e) => { this.aoSelecionarLanceInfinito(e); })
      this.elAumentarCapacidadeVendaAtiva.on('change', (e) => { this.aoAumentarCapacidadeVendaAtiva(e); })
      this.elRelistar.on('change', (e) => { this.aoSelecionarRelistar(e); })
      this.elRetirarVendidos.on('change', (e) => { this.aoSelecionarRetirarVendidos(e); })
      this.elPularAnimacaoAberturaPacote.on('change', (e) => { this.aoSelecionarPularAnimacaoAberturaPacote(e); })
      this.elEvitarPrejuizoVenda.on('change', (e) => { this.aoSelecionarEvitarPrejuizoVenda(e); })
      this.elAtivarModoBackground.on('change', (e) => { this.aoAtivarModoBackground(e); })
      this.elAtivarResolvedorDeCaptcha.on('change', (e) => { this.aoSelecionarResolverCaptchaAutomaticamente(e); })
      this.elAtivarProxy.on('change', (e) => { this.aoSelecionarAtivarProxy(e); })
      this.elAtivarModoHumano.on('change', (e) => { this.aoAtivarModoHumano(e); })
      this.elBotaoSalvarConfigAnticaptcha.on('click', (e) => { this.aoAlterarValorAnticaptcha(e); })
      this.elBotaoSalvarConfigProxy.on('click', (e) => { this.aoAlterarValorProxy(e); })

      this.elNavegadorModificado.on('change', (e) => { this.aoSelecionarNavegadorModificado(e); })
      this.elEconomizarMemoria.on('change', (e) => { this.aoSelecionarEconomizarMemoria(e); })
      this.elHeadless.on('change', (e) => { this.aoSelecionarHeadless(e); })



      this.elCampoNoUiSliderModoPotente = new CampoNoUiSlider().inicializarCampo(this.elParentModalConfiguracao.find('.slider-potencia').attr('id'), this.elCampoModopotente,
        App.Util.getRangeValuesNoUiSlider(this.elCampoModopotente));

      this.elCampoNoUiSliderModoPotente.noUiSlider.on('set', (values: any, handle: any) => {
        this.aoSelecionarPotencia(values, handle, this.elCampoModopotente)
      });

      this.elParentModalConfiguracao.on('show.bs.modal', function (e: JQueryEventObject) {
        this.idContaEa = $(this).data('idContaEa')
        console.log("show.bs.modal", this.idContaEa);
        let opcaoConfig = $(e.relatedTarget).data('config')
        switch (opcaoConfig) {
          case 'config':
            $(this).find('.config-geral').show()
            $(this).find('.config-captcha').hide()
            $(this).find('.config-potencia').hide()
            $(this).find('.config-proxy').hide()
            $(this).find('.config-api-venda-coins').hide()
            break;
          case 'potencia':
            $(this).find('.config-api-venda-coins').hide()
            $(this).find('.config-potencia').show()
            $(this).find('.config-geral').hide()
            $(this).find('.config-captcha').hide()
            $(this).find('.config-proxy').hide()
            break;
          case 'captcha':
            $(this).find('.config-captcha').show()
            $(this).find('.config-geral').hide()
            $(this).find('.config-potencia').hide()
            $(this).find('.config-proxy').hide()
            $(this).find('.config-api-venda-coins').hide()
            break;
          case 'proxy':
            $(this).find('.config-proxy').show()
            $(this).find('.config-geral').hide()
            $(this).find('.config-captcha').hide()
            $(this).find('.config-potencia').hide()
            $(this).find('.config-api-venda-coins').hide()
            break;
          case 'api-venda-coins':
            $(this).find('.config-api-venda-coins').show()
            $(this).find('.config-proxy').hide()
            $(this).find('.config-geral').hide()
            $(this).find('.config-captcha').hide()
            $(this).find('.config-potencia').hide()
            break;
        }
      })

      this.elFormConfiguracoesSniper.attr('autocomplete', 'off');
      this.elInputProxyAddressAnticaptcha.attr('autocomplete', 'off');
      this.elInputProxyPortAnticaptcha.attr('autocomplete', 'off');
      this.elInputProxyLoginAnticaptcha.attr('autocomplete', 'off');
      this.elInputProxyPasswordAnticaptcha.attr('autocomplete', 'off');
    }

    public setConfiguracoes(dadosConfiguracoes: IConfiguracoesConta) {
      console.log("dadosConfiguracoes", dadosConfiguracoes)
      this.elAtivarManterNoCemiterio.prop("checked", Boolean(dadosConfiguracoes.manter_no_cemiterio));
      this.elLanceInfinito.prop("checked", Boolean(dadosConfiguracoes.lance_infinito));
      this.elAumentarCapacidadeVendaAtiva.prop("checked", Boolean(dadosConfiguracoes.aumentar_capacidade_venda_ativa));
      this.checkRadioByValue(this.elRelistar, dadosConfiguracoes.relistar);
      this.elNavegadorModificado.prop("checked", Boolean(dadosConfiguracoes.navegador_modificado));
      this.elHeadless.prop("checked", Boolean(dadosConfiguracoes.headless));
      this.elEconomizarMemoria.prop("checked", Boolean(dadosConfiguracoes.economizar_memoria));
      this.elRetirarVendidos.prop("checked", Boolean(dadosConfiguracoes.retirar_vendidos));
      this.elPularAnimacaoAberturaPacote.prop("checked", Boolean(dadosConfiguracoes.pular_animacao_abertura_pacote));
      this.elEvitarPrejuizoVenda.prop("checked", Boolean(dadosConfiguracoes.evitar_prejuizo_venda));
      this.elAtivarModoBackground.prop("checked", Boolean(dadosConfiguracoes.modo_background));
      this.elAtivarResolvedorDeCaptcha.prop("checked", Boolean(dadosConfiguracoes.resolver_captcha_automaticamente));
      this.elAtivarProxy.prop("checked", Boolean(dadosConfiguracoes.ativar_proxy));
      this.elAtivarModoHumano.prop("checked", Boolean(dadosConfiguracoes.modo_humano));
      this.tratarConfiguracaoSolucaoCaptcha(this.elAtivarResolvedorDeCaptcha)
      this.tratarConfiguracaoProxy(this.elAtivarProxy)
      this.elCampoNoUiSliderModoPotente.noUiSlider.set(dadosConfiguracoes.modo_potente);

      this.elInputAnticaptchaApi.val(dadosConfiguracoes.anticaptcha.api_key);
      this.elInputProxyAddressAnticaptcha.val(dadosConfiguracoes.anticaptcha.proxy_address);
      this.elInputProxyPortAnticaptcha.val(dadosConfiguracoes.anticaptcha.proxy_port);
      this.elInputProxyLoginAnticaptcha.val(dadosConfiguracoes.anticaptcha.proxy_login);
      this.elInputProxyPasswordAnticaptcha.val(dadosConfiguracoes.anticaptcha.proxy_password);
    }

    public checkRadioByValue(el: JQuery, value: any) {
      el.each(function (index: any) {
        if ($(this).val() == value) {
          $(this).prop("checked", true)
        }
      });
    }
    public getIdContaEa(el: JQuery) {
      let idContaEaCurrent = el.parents('.modal-config-extensao').data('idContaEa')
      return idContaEaCurrent ? idContaEaCurrent : this.idContaEa
    }

    private aoSelecionarManterNoCemiterio(e: JQueryEventObject) {
      this.idContaEa = this.getIdContaEa($(e.currentTarget))
      if ($(e.target).is(':checked')) {
        if (!App.Util.existeElementoNaPagina($('.sniper-page-extensao'))) {
          App.Util.exibirAlertaConfirmacaoSwal({
            title: 'Tem certeza disso?',
            text: "Quando habilitado, os itens comprados serão armazenados na sua lista de ítens não atribuídos, essa é uma opção com enorme risco para sua conta",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#db7250',
            cancelButtonColor: '#2dce89',
            confirmButtonText: 'Sim, estou ciente dos riscos.',
            cancelButtonText: "manter desabilitado"
          }, (result: any) => {
            if (result) {
              this.ajax.postAcaoSemResposta($(e.target).data('url'), { id_conta_ea: this.idContaEa, manter_no_cemiterio: true });
            } else {
              $(e.target).prop("checked", false);
            }
          }, this.versaoWeetalert)
        } else {
          this.ajax.postAcaoSemResposta($(e.target).data('url'), { id_conta_ea: this.idContaEa, manter_no_cemiterio: true });
          if (this.executarCallbackChange) {
            this.executarCallbackChange({ manter_no_cemiterio: $(e.target).is(':checked') }, this.idContaEa);
          }
        }
      } else {
        this.ajax.postAcaoSemResposta($(e.target).data('url'), { id_conta_ea: this.idContaEa, manter_no_cemiterio: $(e.target).is(':checked') });
        if (this.executarCallbackChange) {
          this.executarCallbackChange({ manter_no_cemiterio: $(e.target).is(':checked') }, this.idContaEa);
        }
      }
    }

    private aoSelecionarLanceInfinito(e: JQueryEventObject) {
      this.idContaEa = this.getIdContaEa($(e.currentTarget))
      this.ajax.postAcaoSemResposta($(e.target).data('url'), { id_conta_ea: this.idContaEa, lance_infinito: $(e.target).is(':checked') });
      if (this.executarCallbackChange) {
        this.executarCallbackChange({ lance_infinito: $(e.target).is(':checked') }, this.idContaEa);
      }
    }
    private aoAumentarCapacidadeVendaAtiva(e: JQueryEventObject) {
      this.idContaEa = this.getIdContaEa($(e.currentTarget))
      this.ajax.postAcaoSemResposta($(e.target).data('url'), { id_conta_ea: this.idContaEa, aumentar_capacidade_venda_ativa: $(e.target).is(':checked') });
      if (this.executarCallbackChange) {
        this.executarCallbackChange({ aumentar_capacidade_venda_ativa: $(e.target).is(':checked') }, this.idContaEa);
      }
    }
    private aoSelecionarRelistar(e: JQueryEventObject) {
      this.idContaEa = this.getIdContaEa($(e.currentTarget))
      this.ajax.postAcaoSemResposta($(e.target).data('url'), { id_conta_ea: this.idContaEa, relistar: parseInt($(e.target).val()) });
      if (this.executarCallbackChange) {
        this.executarCallbackChange({ relistar: parseInt($(e.target).val()) }, this.idContaEa);
      }
    }
    private aoSelecionarRetirarVendidos(e: JQueryEventObject) {
      this.idContaEa = this.getIdContaEa($(e.currentTarget))
      this.ajax.postAcaoSemResposta($(e.target).data('url'), { id_conta_ea: this.idContaEa, retirar_vendidos: $(e.target).is(':checked') });
      if (this.executarCallbackChange) {
        this.executarCallbackChange({ retirar_vendidos: $(e.target).is(':checked') }, this.idContaEa);
      }
    }
    private aoSelecionarPularAnimacaoAberturaPacote(e: JQueryEventObject) {
      this.idContaEa = this.getIdContaEa($(e.currentTarget))
      this.ajax.postAcaoSemResposta($(e.target).data('url'), { id_conta_ea: this.idContaEa, pular_animacao_abertura_pacote: $(e.target).is(':checked') });
      if (this.executarCallbackChange) {
        this.executarCallbackChange({ pular_animacao_abertura_pacote: $(e.target).is(':checked') }, this.idContaEa);
      }
    }
    private aoSelecionarNavegadorModificado(e: JQueryEventObject) {
      this.idContaEa = this.getIdContaEa($(e.currentTarget))
      this.ajax.postAcaoSemResposta($(e.target).data('url'), { id_conta_ea: this.idContaEa, navegador_modificado: $(e.target).val() });
      if (this.executarCallbackChange) {
        this.executarCallbackChange({ navegador_modificado: $(e.target).val() }, this.idContaEa);
      }
    }
    private aoSelecionarHeadless(e: JQueryEventObject) {
      this.idContaEa = this.getIdContaEa($(e.currentTarget))
      this.ajax.postAcaoSemResposta($(e.target).data('url'), { id_conta_ea: $(e.target).data('idContaEa'), headless: $(e.target).is(':checked') });
      if (this.executarCallbackChange) {
        this.executarCallbackChange({ headless: $(e.target).is(':checked') }, this.idContaEa);
      }
    }

    private aoSelecionarEconomizarMemoria(e: JQueryEventObject) {
      this.idContaEa = this.getIdContaEa($(e.currentTarget))
      this.ajax.postAcaoSemResposta($(e.target).data('url'), { id_conta_ea: this.idContaEa, economizar_memoria: $(e.target).val() });
      if (this.executarCallbackChange) {
        this.executarCallbackChange({ economizar_memoria: $(e.target).val() }, this.idContaEa);
      }
    }

    private aoSelecionarEvitarPrejuizoVenda(e: JQueryEventObject) {
      this.idContaEa = this.getIdContaEa($(e.currentTarget))
      this.ajax.postAcaoSemResposta($(e.target).data('url'), { id_conta_ea: this.idContaEa, evitar_prejuizo_venda: $(e.target).is(':checked') });
      if (this.executarCallbackChange) {
        this.executarCallbackChange({ evitar_prejuizo_venda: $(e.target).is(':checked') }, this.idContaEa);
      }
    }

    private aoAtivarModoBackground(e: JQueryEventObject) {
      this.idContaEa = this.getIdContaEa($(e.currentTarget))
      this.ajax.postAcaoSemResposta($(e.target).data('url'), { id_conta_ea: this.idContaEa, modo_background: $(e.target).is(':checked') });
      if (this.executarCallbackChange) {
        this.executarCallbackChange({ modo_background: $(e.target).is(':checked') }, this.idContaEa);
      }
    }

    private aoAtivarModoHumano(e: JQueryEventObject) {
      this.idContaEa = this.getIdContaEa($(e.currentTarget))
      this.ajax.postAcaoSemResposta($(e.target).data('url'), { id_conta_ea: this.idContaEa, modo_humano: $(e.target).is(':checked') });
      if (this.executarCallbackChange) {
        this.executarCallbackChange({ modo_humano: $(e.target).is(':checked') }, this.idContaEa);
      }
    }

    private tratarConfiguracaoSolucaoCaptcha(checkCaptcha: JQuery): any {
      let resolverCaptchaAutomaticamente = checkCaptcha.is(':checked')
      let parent = checkCaptcha.parents('.modal-config-extensao')
      this.exibirInfoSolucaoDeCaptchaAtiva(resolverCaptchaAutomaticamente);
      if (resolverCaptchaAutomaticamente) {
        parent.find(".form_resolver_captcha_automaticamente").show()
        $("#infoAutoCaptchaLig").show();
        $("#infoAutoCaptchaDeslig").hide();
      } else {
        $("#infoAutoCaptchaDeslig").show();
        $("#infoAutoCaptchaLig").hide();
        parent.find(".form_resolver_captcha_automaticamente").hide()
      }
    }
    private tratarConfiguracaoProxy(checkProxy: JQuery): any {
      let proxyAtivo = checkProxy.is(':checked')
      let parent = checkProxy.parents('.modal-config-extensao')
      this.exibirInfoSolucaoDeCaptchaAtiva(proxyAtivo);
      if (proxyAtivo) {
        parent.find(".form_ativar_proxy").show()
      } else {
        parent.find(".form_ativar_proxy").hide()
      }
    }

    private exibirInfoSolucaoDeCaptchaAtiva(resolverCaptchaAutomaticamente: boolean): any {
      if (resolverCaptchaAutomaticamente) {
        $('.captcha-automatico-info').show();
      } else {
        $('.captcha-automatico-info').hide();

      }
    }
    private aoSelecionarResolverCaptchaAutomaticamente(e: JQueryEventObject) {
      this.idContaEa = this.getIdContaEa($(e.currentTarget))
      this.tratarConfiguracaoSolucaoCaptcha($(e.currentTarget))
      this.ajax.postAcaoSemResposta($(e.target).data('url'), { id_conta_ea: this.idContaEa, resolver_captcha_automaticamente: $(e.target).is(':checked'), dados_anticaptcha: this.getObjDadosSolucaoAntiCaptcha(e) });
      if (this.executarCallbackChange) {
        this.executarCallbackChange({ resolver_captcha_automaticamente: $(e.target).is(':checked') }, this.idContaEa);
      }
    }
    private aoSelecionarAtivarProxy(e: JQueryEventObject) {
      this.idContaEa = this.getIdContaEa($(e.currentTarget))
      console.log("aoSelecionarAtivarProxy", this.idContaEa)
      this.tratarConfiguracaoProxy($(e.currentTarget))
      this.ajax.postAcaoSemResposta($(e.target).data('url'), { id_conta_ea: this.idContaEa, ativar_proxy: $(e.target).is(':checked'), dados_proxy: null });
      if (this.executarCallbackChange) {
        this.executarCallbackChange({ ativar_proxy: $(e.target).is(':checked') }, this.idContaEa, this.getObjDadosProxy(e));
      }
    }

    private aoAlterarValorAnticaptcha(e: JQueryEventObject) {
      this.idContaEa = this.getIdContaEa($(e.currentTarget))
      this.ajax.postAcaoSemResposta(this.elAtivarResolvedorDeCaptcha.data('url'), { id_conta_ea: this.idContaEa, resolver_captcha_automaticamente: this.elAtivarResolvedorDeCaptcha.is(':checked'), dados_anticaptcha: this.getObjDadosSolucaoAntiCaptcha(e) });
      toastr.success("Os dados foram salvos.", "Sucesso!");
    }

    private aoAlterarValorProxy(e: JQueryEventObject) {
      this.idContaEa = this.getIdContaEa($(e.currentTarget))
      this.ajax.postAcaoSemResposta(this.elAtivarProxy.data('url'), { id_conta_ea: this.idContaEa, ativar_proxy: this.elAtivarProxy.is(':checked'), dados_proxy: this.getObjDadosProxy(e) });
      if (this.executarCallbackChange) {
        this.executarCallbackChange({ ativar_proxy: this.elAtivarProxy.is(':checked') }, this.idContaEa, this.getObjDadosProxy(e));
      }
      toastr.success("Os dados foram salvos.", "Sucesso!");
    }

    public getObjDadosSolucaoAntiCaptcha(e: JQueryEventObject = null): ICaptchaSolutionAnticaptcha {
      if (e) {
        var formContext = $(e.currentTarget).parents('.form_resolver_captcha_automaticamente')
        return {
          api_key: formContext.find('input[name=api_key]').val(),
          proxy_address: formContext.find('input[name=proxy_address]').val(),
          proxy_port: formContext.find('input[name=proxy_port]').val(),
          proxy_login: formContext.find('input[name=proxy_login]').val(),
          proxy_password: formContext.find('input[name=proxy_password]').val()
        }
      } else {
        return {
          api_key: this.elInputAnticaptchaApi.val(),
          proxy_address: this.elInputProxyAddressAnticaptcha.val(),
          proxy_port: this.elInputProxyPortAnticaptcha.val(),
          proxy_login: this.elInputProxyLoginAnticaptcha.val(),
          proxy_password: this.elInputProxyPasswordAnticaptcha.val()
        }
      }
    }

    public getObjDadosProxy(e: JQueryEventObject = null): IDadosProxy {
      if (e) {
        var formContext = $(e.currentTarget).parents('.config-proxy').find('.form_ativar_proxy')
        console.log("aqui", formContext.find('input[name=proxy_address]').val())
        return {
          protocolo: formContext.find('select[name=protocolo]').find(':selected').text(),
          proxy_address: formContext.find('input[name=proxy_address]').val(),
          proxy_port: formContext.find('input[name=proxy_port]').val(),
          proxy_login: formContext.find('input[name=proxy_login]').val(),
          proxy_password: formContext.find('input[name=proxy_password]').val()
        }
      } else {
        return {
          protocolo: this.elSelectProtocoloProxy.find(':selected').text(),
          proxy_address: this.elInputProxyAddress.val(),
          proxy_port: this.elInputProxyPort.val(),
          proxy_login: this.elInputProxyLogin.val(),
          proxy_password: this.elInputProxyPassword.val()
        }
      }
    }

    private aoSelecionarPotencia(values: any, handle: any, el: JQuery) {
      this.idContaEa = this.getIdContaEa(el)
      var valor = parseInt(values[handle]);
      $('input[name=modo_potente]').val(valor);
      this.exibirInfoPotencia(valor);
      this.ajax.postAcaoSemResposta(el.data('url'), { id_conta_ea: this.idContaEa, modo_potente: valor });
      if (this.executarCallbackChange) {
        this.executarCallbackChange({ modo_potente: valor }, this.idContaEa);
      }
    }

    private exibirInfoPotencia(potencia: number): any {
      $('.potencia-info').hide();
      $('.potencia-info-' + potencia).show();
    }
  }
}
